var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChefHatAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.584V17.25H19V13.584C20.7659 12.8124 22 11.0503 22 9C22 6.23858 19.7614 4 17 4C16.6803 4 16.3676 4.03001 16.0645 4.08737C15.1571 2.82336 13.6747 2 12 2C10.3253 2 8.84287 2.82336 7.93548 4.08736C7.63244 4.03001 7.31972 4 7 4C4.23858 4 2 6.23858 2 9C2 11.0503 3.2341 12.8124 5 13.584ZM12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V12C11.25 11.5858 11.5858 11.25 12 11.25ZM7.8181 11.2724C8.21994 11.1719 8.62715 11.4163 8.72761 11.8181L9.72761 15.8181C9.82807 16.2199 9.58375 16.6271 9.1819 16.7276C8.78006 16.8281 8.37285 16.5837 8.27239 16.1819L7.27239 12.1819C7.17193 11.7801 7.41625 11.3729 7.8181 11.2724ZM15.2724 11.8181C15.3729 11.4163 15.7801 11.1719 16.1819 11.2724C16.5837 11.3729 16.8281 11.7801 16.7276 12.1819L15.7276 16.1819C15.6271 16.5837 15.2199 16.8281 14.8181 16.7276C14.4163 16.6271 14.1719 16.2199 14.2724 15.8181L15.2724 11.8181Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.75V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V18.75H5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefHatAlt);
export default __webpack_public_path__ + "static/media/chef-hat-alt.379675771f5f4fafff9cab8a87faede8.svg";
export { ForwardRef as ReactComponent };